export default function useExtractPIN() {
    const extractPIN = (pin) => {
        let pinArray = pin?.map((item) => (item.value));
        let result = pinArray?.join('').toString();
        return result
    }

    return { extractPIN }
}